import { withInstall } from '@jdesign-vue/utils'

import Slider from './src/slider.vue'

export const JdSlider = withInstall(Slider)
export default JdSlider

export * from './src/slider'
export * from './src/constants'
